var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrossPlus = function SvgCrossPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "social-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cross-plus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106150",
    d: "M222.14 222.14h20v20h-20Z",
    transform: "translate(-222.14 -222.14)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cross-plus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106149",
    d: "M10 0a10 10 0 1 0 5 1.34A10 10 0 0 0 10 0Zm0 1.712a8.287 8.287 0 1 1-4.144 1.11A8.288 8.288 0 0 1 10 1.713Zm-.456 2.916a.487.487 0 0 0-.488.488v3.939H5.117a.487.487 0 0 0-.488.488v.913a.487.487 0 0 0 .488.488h3.939v3.939a.487.487 0 0 0 .488.488h.913a.487.487 0 0 0 .488-.488v-3.939h3.939a.487.487 0 0 0 .488-.488v-.913a.487.487 0 0 0-.488-.488h-3.939V5.116a.487.487 0 0 0-.488-.488Z"
  }))));
};
export default SvgCrossPlus;